import { observer } from "mobx-react";
import { FC } from "react";
import styled from "styled-components";

const MasterBlock = styled.div`
  max-width: 100%;
  padding: 20px 45px;
  border-radius: 25px;
  transition: background 0.3s;
  cursor: pointer;

  :hover {
    background: #f6f6f6;
  }

  @media (max-width: 450px) {
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 10px;
  }
`;

const Image = styled.img`
  width: 130px;
  height: 130px;
  border-radius: 500px;
  margin-top: 20px;

  @media (max-width: 450px) {
    width: 48px;
    height: 48px;
    margin: 0;
    border-radius: 8px;
  }
`;

const Name = styled.p`
  text-align: center;
  font-size: 18px;
  margin-bottom: 5px;
  @media(max-width: 480px) {
    margin: 0;
    text-align: left;
  }
`;

// const Stat = styled.p`
//   margin: 0;
//   font-size: 14px;
//   margin-top: 6px;
//   color: #888888;
//   @media(min-width: 480px) {
//     text-align: center;
//     margin-top: 0;
//   }
// `;

const MasterCard: FC<{ name: string; photo: string; stat: object[]; onClick?: React.MouseEventHandler<HTMLDivElement> }> = observer(
  ({ name, photo, stat, onClick }) => {
    return (
      <MasterBlock onClick={onClick}>
        <Image src={photo} alt="avatar" />
        <div>
          <Name>{name}</Name>
        </div>
      </MasterBlock>
    );
  }
);

export default MasterCard;
